import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 18rem;
  height: 16rem;
  border: 0.95px solid var(--Stroke, rgba(241, 243, 247, 0.8));
  border-radius: 7.601px;
  background-color: #ffffff;
  box-shadow: 0px 0px 19px -3px rgba(13, 13, 13, 0.09);
  padding: 18px 32px 0 32px;
  gap: 1rem;

  @media (max-width: 1024px) {
    margin-left: auto;
    margin-right: auto;
  }

  @media (max-width: 767px) {
    margin-top: 10px;
    margin-bottom: 20px;
  }
`;

export const Image = styled.div`
  width: 60px;
  height: 60px;

  img {
    width: 100%;
    max-width: 16.125rem;
  }
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  ${({ hasTooltip }) =>
    hasTooltip &&
    css`
      cursor: pointer;
    `}
`;

export const Title = styled.h2`
  color: #230c87;
  font-family: "Platform Web";
  font-size: 16.08px;
  font-style: normal;
  font-weight: 500;
  line-height: 25px;
`;

export const ToolTipContainer = styled.div`
  position: absolute;
  width: 100%;

  @media (max-width: 767px) {
    top: -96px;
  }
`;

export const Description = styled.p`
  width: 100%;
  position: relative;
  color: #230c87;
  font-family: "Work Sans";
  font-size: 12.865px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  opacity: 0.7;

  span {
    position: relative;
    font-weight: 700;

    cursor: pointer;
    text-decoration: underline;

    img {
      position: relative;
      top: 3px;
    }
  }
`;

export const LinkFooter = styled.a`
  position: relative;
  opacity: 0.7;
  color: #230c87;
  font-family: "Work Sans";
  font-size: 12.865px;
  font-style: normal;
  font-weight: 700;
  line-height: 142.8%;
  text-decoration-line: underline;
  cursor: pointer;
`;

export const TooltipLink = styled(LinkFooter)`
  width: 100%;
  padding-right: 30px;
  line-height: 12px;

  span {
    position: relative;
    font-weight: 700;

    cursor: pointer;
    text-decoration: underline;

    img {
      position: relative;
      top: 4px;
      margin-left: 3px;
    }
  }
`;

export const TooltipTitle = styled.div`
  display: flex;
  position: relative;
  gap: 5px;

  span {
    color: #230c87;
    font-family: "Work Sans";
    font-weight: 400 !important;
    font-size: 14px;
    line-height: 24px;
    font-style: normal;
    line-height: normal;
    text-decoration: underline;
    cursor: text !important;
  }

  button {
    padding: 3px 0 3px 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    top: -10px;
    right: -5px;
    height: min-content;
    width: min-content;

    background: transparent;
    border: none;

    @media (max-width: 767px) {
      padding: 7px;
    }
  }
`;

export const TooltipDescription = styled.p`
  width: 95%;
  color: #230c87;
  font-family: "Work Sans";
  font-weight: 400;
  line-height: 24px;
  font-size: 14px;
  font-style: normal;
  line-height: normal;
`;
